import { useMemo, useState } from 'react';

export interface PagingOptions {
  /**
   * @default 10
   */
  initialPageSize?: number;
  /**
   * @default 0
   */
  initialPage?: number;
  rowCount: number | null | undefined;
}

export interface PagingData {
  currentPage: number;
  setCurrentPage: (currentPage: number) => void;
  pageSize: number;
  setPageSize: (pageSize: number) => void;
  rowCount: number;
}

export const usePaging = (options: PagingOptions): PagingData => {
  const [currentPage, setCurrentPageInternal] = useState(options.initialPage || 0);
  const [pageSize, setPageSizeInternal] = useState(options.initialPageSize || 10);
  const rowCount = useMemo(() => options.rowCount || 0, [options]);

  const setPageSize = (value: number) => {
    if (value * currentPage > rowCount) {
      setCurrentPageInternal(Math.ceil(rowCount / value) - 1);
    }
    setPageSizeInternal(value);
  };

  const setCurrentPage = (value: number) => {
    setCurrentPageInternal(value);
  };

  return { currentPage, setCurrentPage, pageSize, setPageSize, rowCount };
};
